import React from 'react';
import { ArticleConstants } from '../../adapters/helpers/Constants';
import { AssetProps } from '../../types';

interface ArticleSignupProps {
    signupContent?: {
        fields?: {
            className?: string;
            contentType?: string;
            ctaButton?: {
                fields?: {
                    contentType?: string;
                    ctaName?: string;
                    ctaUrl?: string;
                };
            };
            description?: string;
            image?: {
                fields?: {
                    alternateText?: string;
                    asset?: AssetProps;
                };
            };
            title?: string;
        };
    };
}

const ArticleSignup: React.FC<ArticleSignupProps> = ({ signupContent }) => {
    const { title, description, ctaButton, image } = signupContent?.fields || {};
    const ctaName = ctaButton?.fields?.ctaName;
    const ctaUrl = ctaButton?.fields?.ctaUrl;
    const imageUrl = image?.fields?.asset?.fields?.file?.url;
    const imageAltText = image?.fields?.alternateText;

    const handleButtonClick = (url: string) => {
        window.open(url, '_blank');
    };

    return (
        <div className='article-revamp-signup bg-revamp_bg w-auto lg:w-full m-11 lg:m-0 px-2 pt-2 pb-0 rounded-2xl flex flex-col items-center justify-center'>
            {title && <h2 className='font-bold text-25 leading-30 text-white text-center pb-[5px]'>{title}</h2>}
            {description && <p className='font-light text-25 leading-30 text-white text-center'>{description}</p>}
            {ctaUrl && (
                <button onClick={() => handleButtonClick(ctaUrl)} className='revamp-signup-btn w-8/12 bg-revamp_white text-revamp_btn_blue font-semi-bold text-xs text-center py-1 px-4 mt-14 mb-8 rounded-full'>
                    {ctaName}
                </button>
            )}
            {imageUrl && (
                <img
                    src={`https:${imageUrl}`}
                    alt={imageAltText || ArticleConstants.SignUpImage}
                    width={500}
                    height={400}
                    className='w-9/12'
                />
            )}
        </div>
    );
};

export default ArticleSignup;